export default __webpack_public_path__ + "static/media/webinars.f96c6fec.svg";